
export const tourData=[
    {
        id:1,
        art: "Landscape",
        img : './art gallary img/landscape.jpg',
        name: "Alora Dewn",
        price: "10,000/-",
        info:
        "Landscape painting, also known as landscape art, is the depiction of natural scenery such as mountains, valleys, trees, rivers, and forests, especially where the main subject is a wide view—with its elements arranged into a coherent composition. In other works, landscape backgrounds for figures can still form an important part of the work.",
    },
    {
        id:2,
        art: "Canvas",
        img: "./art gallary img/canvas2.jpg",
        name: "Rose Moren",
        price: "30,000/-",
        info: 
        "Canvas is an extremely durable plain-woven fabric used for making sails, tents, marquees, backpacks, shelters, as a support for oil painting and for other items for which sturdiness is required, as well as in such fashion objects as handbags, electronic device cases, and shoes. It is also popularly used by artists as a painting surface, typically stretched across a wooden frame.",
    },
    {
        id:3,
        art: "Nature",
        img: "./art gallary img/nature.jpg",
        name: "Aman Ahuja",
        price: "15,000/-",
        info: 
        "Edit Patterns in nature are visible regularities of form found in the natural world. These patterns recur in different contexts and can sometimes be modelled mathematically. Natural patterns include symmetries, trees, spirals, meanders, waves, foams, tessellations, cracks and stripes.",
    },
    {
        id:4,
        art: "Modren Oil",
        img: "./art gallary img/modern oil.jpg",
        name: "Kiara Taylor",
        price: "25,000/-",
        info: 
        "Modern art includes artistic work produced during the period extending roughly from the 1860s to the 1970s, and denotes the styles and philosophies of the art produced during that era. The term is usually associated with art in which the traditions of the past have been thrown aside in a spirit of experimentation.",
    },
    {
        id:5,
        art: "Potrait",
        img: "./art gallary img/potrait.jpg",
        name: "Robin Demiz",
        price: "20,000/-",
        info: 
        "A portrait is a painting, photograph, sculpture, or other artistic representation of a person, in which the face and its expression is predominant. The intent is to display the likeness, personality, and even the mood of the person. For this reason, in photography a portrait is generally not a snapshot, but a composed image of a person in a still position.",
    },
    {
        id:6,
        art: "Oil Painting",
        img: "./art gallary img/oil.jpg",
        name: "John Vaste",
        price: "10,000/-",
        info: 
        "Modern art includes artistic work produced during the period extending roughly from the 1860s to the 1970s, and denotes the styles and philosophies of the art produced during that era. The term is usually associated with art in which the traditions of the past have been thrown aside in a spirit of experimentation.",
    },

];